 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP133647 from '@/components/chap133647'
 import CHAP133645 from '@/components/chap133645'
 import CHAP138427 from '@/components/chap138427'
 import CHAP133644 from '@/components/chap133644'
 import CHAP133649 from '@/components/chap133649'
 import CHAP133648 from '@/components/chap133648'
 import CHAP133655 from '@/components/chap133655'
 import CHAP133656 from '@/components/chap133656'
 import CHAP133657 from '@/components/chap133657'
 import CHAP133652 from '@/components/chap133652'
 import CHAP133642 from '@/components/chap133642'
 import CHAP133653 from '@/components/chap133653'
 import CHAP133658 from '@/components/chap133658'
 import CHAP133650 from '@/components/chap133650'
 import CHAP133651 from '@/components/chap133651'
 import CHAP133646 from '@/components/chap133646'
 import CHAP133643 from '@/components/chap133643'
 import LOVE_2 from '@/components/love_2'
 import CHAP153849 from '@/components/chap153849'
 import CHAP134364 from '@/components/chap134364'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap133647",
 			"name" : "chap133647",
 			"component" : CHAP133647
 		},
 		{
 			"path" : "/chap133645",
 			"name" : "chap133645",
 			"component" : CHAP133645
 		},
 		{
 			"path" : "/chap138427",
 			"name" : "chap138427",
 			"component" : CHAP138427
 		},
 		{
 			"path" : "/chap133644",
 			"name" : "chap133644",
 			"component" : CHAP133644
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js